import { CheckCircle2, Trash2 } from 'lucide-react';
import { useSincronizacion } from '@/api/offline/sincronizacion';
import { EncabezadoPagina, ModuleLayout } from '@/components/layout/ModuleLayout';
import { Button } from '@/components/ui/button';
import { Tarjeta, Vacio } from '@/components/ui/data';
import { fechaHora } from '@/lib/utils';

const ACCIONES: [RegExp, string][] = [
  [/^\/citas$/, 'Nueva cita'],
  [/^\/citas\/[^/]+$/, 'Editar cita'],
  [/^\/citas\/[^/]+\/reprogramar$/, 'Reprogramar cita'],
  [/^\/citas\/[^/]+\/asignar$/, 'Asignar barbero'],
  [/^\/citas\/[^/]+\/cancelar$/, 'Cancelar cita'],
  [/^\/clientes/, 'Cliente'],
  [/^\/atencion/, 'Atención'],
  [/^\/ventas/, 'Carrito'],
  [/^\/asistencia/, 'Checador'],
];
const accion = (ruta: string) => ACCIONES.find(([r]) => r.test(ruta))?.[1] ?? ruta;

/** Cambios hechos sin conexión que el servidor rechazó (por ejemplo, un horario que ya se ocupó). */
export function PendientesPage() {
  const { conflictos, descartar } = useSincronizacion();
  return (
    <ModuleLayout titulo="Pendientes de revisar">
      <EncabezadoPagina
        titulo="Pendientes de revisar"
        descripcion="Estos cambios se hicieron sin conexión y el servidor no los aceptó al reconectar. Vuelve a capturarlos si siguen siendo necesarios y descártalos."
      />
      {conflictos.length === 0 ? (
        <Tarjeta>
          <Vacio icono={<CheckCircle2 />} titulo="Todo sincronizado" descripcion="No hay cambios pendientes de revisar." />
        </Tarjeta>
      ) : (
        <div className="grid gap-3">
          {conflictos.map((m) => (
            <Tarjeta key={m.id} className="flex flex-wrap items-center gap-3 p-4">
              <div className="min-w-0 flex-1">
                <p className="font-medium">{accion(m.ruta)}</p>
                <p className="text-[13px] text-foreground-muted">
                  Hecho el {fechaHora(m.creadaEn)} · {m.intentos} reintento(s)
                </p>
                <pre className="mt-2 max-h-32 overflow-auto rounded-md bg-muted p-2 text-[12px]">{JSON.stringify(m.body, null, 2)}</pre>
              </div>
              <Button variante="secundario" onClick={() => void descartar(m.id)}>
                <Trash2 /> Descartar
              </Button>
            </Tarjeta>
          ))}
        </div>
      )}
    </ModuleLayout>
  );
}
